import {  ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription, take, BehaviorSubject } from 'rxjs';
import { LanguagesEnum } from 'src/common-panel/enums/languages-enum';
import { UserRolesEnum } from 'src/app/common/enums/user-roles-enum';
import { ClinicListItem } from 'src/app/common/models/users-data/clinic-list-item.model';
import { EntOfficeListItem } from 'src/app/common/models/users-data/ent-office-list-item.model';
import { ClinicService } from 'src/app/services/clinic.service';
import { DialogsManagerService } from 'src/app/services/dialogs-manager.service';
import { EntOfficeService } from 'src/app/services/ent-office.service';
import { UserManageService } from 'src/app/services/user-manage.service';
import { UtilsService } from 'src/common-panel/services/utils.service';

@Component({
    selector: 'app-edit-user-dialog',
    templateUrl: './edit-user-dialog.component.html',
    styleUrls: ['./edit-user-dialog.component.css'],
    standalone: false
})
export class EditUserDialogComponent implements OnInit, OnDestroy
{

  subscription: Subscription = new Subscription()

  closedBySubmit = false
  selectedClinic?: string

  form: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")]),
    lastName: new FormControl('', [Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")]),
    clinic: new FormControl(''),
    entOffice: new FormControl(''),
    language: new FormControl('', [Validators.required]),
    shopAdminAccess: new FormControl(''),
    countryShopsAccess: new FormControl(''),
    patientManagerAccess: new FormControl(''),
    advancedMode: new FormControl(''),
  })

  clinicList: ClinicListItem[] = this.clinicService.clinicList
  officeList: EntOfficeListItem[] = this.entOfficeService.entOfficeList

  LanguagesEnum = LanguagesEnum

  clinicsIdsSubject = new BehaviorSubject<string>('No clinics selected yet')

  constructor(private dialogRef: MatDialogRef<any>, private dialogsManagerService: DialogsManagerService, private userManageService: UserManageService,
    private clinicService: ClinicService, private entOfficeService: EntOfficeService, private dialog: MatDialog, private cdr: ChangeDetectorRef) { }

  ngOnDestroy(): void
  {
    this.subscription.unsubscribe()
  }

  ngOnInit(): void
  {
    this.setValuesFromModel()

    if (this.userManageService.currentUser) this.userManageService.newUserClinicList = this.userManageService.currentUser.shopList

    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
    {
      if (!this.closedBySubmit)
      {
        this.userManageService.clearUser()
        this.dialog.closeAll()
      }
    })

    if (this.userManageService.currentClinic) this.selectedClinic = this.userManageService.currentClinic.clinicId;

    let l_sub = this.form.controls['clinic'].valueChanges.subscribe(l_change =>
    {
      if (l_change && l_change.clinicId)
      {
        this.userManageService.currentClinic = l_change
        if (this.userManageService.newUserClinicList.length > 0)
        {
          if (!this.userManageService.newUserClinicList.includes(l_change.clinicId)) this.userManageService.newUserClinicList.push(l_change.clinicId)
        } else
        {
          this.userManageService.newUserClinicList.push(l_change.clinicId)
        }


        if (this.selectedClinic)
        {
          this.userManageService.newUserClinicList.forEach((clinicId, index) =>
          {
            if ((this.selectedClinic != l_change.clinicId) && clinicId == this.selectedClinic) this.userManageService.newUserClinicList.splice(index, 1);
          });
        }
        this.selectedClinic = l_change.clinicId;
      }
      this.cdr.detectChanges();
    })

    let l_sub1 = this.clinicService.defualtClinicToUpdateSubject.subscribe(() =>
    {
      this.form.controls['clinic'].setValue(this.userManageService.currentClinic)
      this.cdr.detectChanges();
    })

    this.subscription.add(l_sub)
    this.subscription.add(l_sub1)
  }



  setValuesFromModel()
  {
    this.form.controls['firstName'].setValue(this.userManageService.currentUser?.firstName)
    this.form.controls['lastName'].setValue(this.userManageService.currentUser?.lastName)
    this.form.controls['language'].setValue(this.userManageService.currentUser?.lang)
    this.form.controls['shopAdminAccess'].setValue(this.userManageService.currentUser?.shopAdminAccess)
    this.form.controls['countryShopsAccess'].setValue(this.userManageService.currentUser?.countryShopsAccess)
    this.form.controls['patientManagerAccess'].setValue(this.userManageService.currentUser?.patientManagerAccess)
    this.form.controls['advancedMode'].setValue(this.userManageService.currentUser?.advancedMode)

    if (this.userManageService.currentClinic) this.form.controls['clinic'].setValue(this.userManageService.currentClinic)
    if (this.userManageService.currentOffice) this.form.controls['entOffice'].setValue(this.userManageService.currentOffice)

  }

  isEnt(): boolean
  {
    if (this.userManageService.currentUser?.role == UserRolesEnum.ent) return true
    else return false
  }

  isDal(): boolean
  {
    if (this.userManageService.currentUser?.role == UserRolesEnum.dal) return true
    else return false
  }

  onSubmit()
  {

    if (this.userManageService.currentUser?.userId)
    {
      this.userManageService.editedUser = {
        userId: this.userManageService.currentUser?.userId,
        role: this.userManageService.currentUser?.role ? this.userManageService.currentUser?.role : UserRolesEnum.none,
        properties: {
          firstName: this.form.controls['firstName'].value,
          lastName: this.form.controls['lastName'].value,
          lang: this.form.controls['language'].value,
          clinicId: this.form.controls['clinic'].value ? this.form.controls['clinic'].value.clinicId : undefined,
          entOfficeId: this.form.controls['entOffice'].value ? this.form.controls['entOffice'].value.entOfficeId : undefined,
          shopAdminAccess:this.form.controls['shopAdminAccess'].value,
          countryShopsAccess: this.form.controls['countryShopsAccess'].value,
          patientManagerAccess: this.form.controls['patientManagerAccess'].value,
          advancedMode: this.form.controls['advancedMode'].value,
        }
      }

      this.userManageService.currentClinic = this.form.controls['clinic'].value
      this.userManageService.currentOffice = this.form.controls['entOffice'].value
      this.dialogsManagerService.showReviewEditUserDialogComponent();

      this.closedBySubmit = true
      this.dialogRef.close('Excellent');
    }
  }

  isStartsWithSubstring(text: string, substring: string): boolean 
  {
    return UtilsService.isStartsWithSubstring(text, substring)
  }

  isDisabledButton(): boolean
  {
    let l_disabled = false
    if (((!this.form.dirty && (!this.userManageService.newUserClinicListUpdatedSubject.value)) || !this.form.valid)) l_disabled = true
    if ((this.userManageService.currentUser?.role != UserRolesEnum.ent) && (this.userManageService.currentUser?.role != UserRolesEnum.dal) && (!this.form.controls['clinic'].value || this.form.controls['clinic'].value.length < 1))
    {
      l_disabled = true
    } else if ((this.userManageService.currentUser?.role == UserRolesEnum.ent) && this.form.controls['entOffice'].value.length < 1)
    {
      l_disabled = true
    }

    return l_disabled
  }

  showSelectClinicsDialog()
  {
    this.dialogsManagerService.showSelectClinicsDialogComponent();
  }

  getClinicsAmount(): number
  {
    if (this.userManageService.newUserClinicList.length > 0)
    {
      return this.userManageService.newUserClinicList.length
    }
    else if (this.userManageService.currentUser)
    {
      if (this.userManageService.currentUser.shopList.length > 0) return this.userManageService.currentUser.shopList.length
      else if (this.userManageService.currentUser.clinicId && this.clinicList.map(l_clinic => l_clinic.clinicId).includes(this.userManageService.currentUser.clinicId)) return 1
      else return 0
    }
    else return 0

  }

  getClinicsIds(): string
  {

      if (this.userManageService.newUserClinicList.length > 0) return this.userManageService.newUserClinicList.join(", ")
      else if (this.userManageService.currentUser)
      {
        if (this.userManageService.currentUser.shopList.length > 0) return this.userManageService.currentUser.shopList.join(',')
        else if (this.userManageService.currentUser.clinicId && this.clinicList.map(l_clinic => l_clinic.clinicId).includes(this.userManageService.currentUser.clinicId)) return this.userManageService.currentUser.clinicId
        else return "No clinics selected yet"
      }
      return "No clinics selected yet"
    
  }
}
